import type { NskResponse } from "~/models/Api";
import type {
	VendorUser,
	VendorUserCreateParam,
	VendorUserSelfUpdateParam,
	VendorUserSettingParam,
	VendorUserUpdatePasswordParam
} from "~/models/VendorUser";
import {
	deleteRequest,
	postRequest,
	putRequest
} from "~/utils/api/api_handler";

const paths = {
	changePassword: "/vendors/vendor_users/change_password",
	create: "/vendors/vendor_users",
	destroy: "/vendors/vendor_users/:id",
	update: "/vendors/vendor_users/:id",
	updateSelf: "/vendors/vendor_users/update_self",
	updateSeq: "/vendors/vendor_users/update_seq"
};

export const create = async (
	vendorUser: VendorUserCreateParam
): Promise<NskResponse> => postRequest(paths.create, { vendorUser });

export const update = async (
	vendorUser: VendorUserSettingParam,
	vendorUserId: number
): Promise<NskResponse> =>
	putRequest(paths.update.replace(":id", String(vendorUserId)), { vendorUser });

export const destroy = async (vendorUserId: number): Promise<NskResponse> =>
	deleteRequest(paths.destroy.replace(":id", String(vendorUserId)));

export const updateSelf = async (
	vendorUser: VendorUserSelfUpdateParam
): Promise<NskResponse> => putRequest(paths.updateSelf, { vendorUser });

export const changePassword = async (
	passwords: VendorUserUpdatePasswordParam
): Promise<NskResponse> => postRequest(paths.changePassword, passwords);

export const updateSeq = async (
	vendorUsers: VendorUser[]
): Promise<NskResponse> => postRequest(paths.updateSeq, { vendorUsers });
